<template>
  <img :src="image" alt="Ask AI image" class="star-icon" />
</template>
<script setup>
import { computed } from 'vue';
import getAssetImage from '~/utils/getAssetImage.ts';
import { GET_IS_DESKTOP_VIEW } from '#shared/types/getters';

const navViewType = useNavViewType();
const isDesktop = computed(() => navViewType[GET_IS_DESKTOP_VIEW]);
const image = computed(() => getAssetImage(isDesktop.value ? 'starIconDesktop.svg' : 'starIcon.svg'));
</script>
